import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f15a5ed8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ncgr-heading -size-s ncgr-mar-b-8 heading" }
const _hoisted_2 = { class: "ncgr-card ncgr-card--rounded-to-normal" }
const _hoisted_3 = { class: "product__image" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "product__form" }
const _hoisted_6 = { class: "ncgr-mar-b-16" }
const _hoisted_7 = { class: "ncgr-text-field" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "_label",
  for: "color"
}, "カラーを選択", -1))
const _hoisted_9 = { class: "_control" }
const _hoisted_10 = ["onChange"]
const _hoisted_11 = ["value", "selected"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_trailing" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_icon" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "ncgr-icon",
      "data-icon": "arrow_drop_down"
    })
  ])
], -1))
const _hoisted_13 = { class: "ncgr-mar-b-16" }
const _hoisted_14 = { class: "ncgr-text-field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "_label",
  for: "size"
}, "サイズを選択", -1))
const _hoisted_16 = { class: "_control" }
const _hoisted_17 = ["onChange"]
const _hoisted_18 = ["value", "selected"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_trailing" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "_icon" }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "ncgr-icon",
      "data-icon": "arrow_drop_down"
    })
  ])
], -1))
const _hoisted_20 = { class: "product__quantity-and-price" }
const _hoisted_21 = { class: "product__quantity" }
const _hoisted_22 = { class: "ncgr-text-field -align-end" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "_label",
  for: "quantity"
}, " 枚数 ", -1))
const _hoisted_24 = { class: "_control" }
const _hoisted_25 = ["value", "onInput"]
const _hoisted_26 = { class: "product__price" }
const _hoisted_27 = { class: "ncgr-typography-bold" }
const _hoisted_28 = { class: "product__delete" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_leading" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "ncgr-icon",
    "data-icon": "cross"
  })
], -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "ncgr-pad-8" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_leading" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "ncgr-icon",
    "data-icon": "plus_on_circle"
  })
], -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_body" }, " カラー・サイズ違いを追加 ", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.campaign.name) + " " + _toDisplayString(_ctx.$t(`item-name.${_ctx.campaign.item.name}.short`)), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selections, (selection, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: selection.id,
          class: "ncgr-container product"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              class: "ncgr-image",
              src: _ctx.thumbnailUrl(selection)
            }, null, 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("select", {
                    id: "color",
                    class: "_input",
                    name: "color",
                    "data-test": "color-select",
                    onChange: ($event: any) => (_ctx.emitChange($event, index, 'variantId'))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaign.variants, (v) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: v.id,
                        value: v.id,
                        selected: selection.variantId === v.id
                      }, _toDisplayString(_ctx.formatItemColor(v)), 9, _hoisted_11))
                    }), 128))
                  ], 40, _hoisted_10),
                  _hoisted_12
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("select", {
                    id: "size",
                    class: "_input",
                    name: "size",
                    "data-test": "size-select",
                    onChange: ($event: any) => (_ctx.emitChange($event, index, 'itemSizeId'))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.campaign.item.sizes, (s) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: s.id,
                        value: s.id,
                        selected: selection.itemSizeId === s.id
                      }, _toDisplayString(_ctx.$t(`item-size.${s.name}`)), 9, _hoisted_18))
                    }), 128))
                  ], 40, _hoisted_17),
                  _hoisted_19
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("input", {
                      class: "_input",
                      type: "number",
                      name: "quantity",
                      min: "1",
                      value: selection.quantity,
                      onInput: ($event: any) => (_ctx.emitChange($event, index, 'quantity'))
                    }, null, 40, _hoisted_25)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.formatPrice(_ctx.findVariant(selection.variantId).priceWithTax)) + "(税込)", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              (index > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "ncgr-button -appearance-transparent -shape-circle",
                    "data-test": "remove-variant",
                    onClick: ($event: any) => (_ctx.removeSelection(index))
                  }, _hoisted_31, 8, _hoisted_29))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("a", {
          class: "ncgr-button -appearance-transparent -width-full",
          href: "#",
          "data-test": "add-variant",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.appendSelection && _ctx.appendSelection(...args)), ["prevent"]))
        }, _hoisted_35)
      ])
    ])
  ]))
}